import { useTranslation } from "react-i18next";
import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import React, { useState } from "react";
import { toNumber } from "lodash";
import { useNavigate } from "react-router-dom";
import { Button, Flex } from "antd";
import useKeyword from "../../../../../hooks/useKeyword";
import useMetaData from "../../../../../hooks/useMetaData";
import { IndustryInfo } from "../../../../../types/course";
import { concatQueryString } from "../../../../../utils/app";
import Banner from "../../../../../components/banner/Banner";
import FormInput from "../../../../../components/form-input/FormInput";
import "./style.scss";

function ProgramsSearchBanner() {
  const { t } = useTranslation();
  const [keyword, setKeyword] = useState<string>(useKeyword("keyword") || "");
  const { allIndustry } = useMetaData();
  const industryId = toNumber(useKeyword("industry"));
  const currentIndustry = allIndustry?.find(
    (item: IndustryInfo) => item.id === industryId
  );
  const currentSearch = location.search;
  const navigate = useNavigate();

  const renderTitle = () => {
    if (currentIndustry)
      return (
        <span>
          {t("Các chương trình học về", "Các chương trình học về")} <br />
          {currentIndustry.name}
        </span>
      );

    return t("Các chương trình học", "Các chương trình học");
  };

  const handleSearch = () => {
    if (keyword) {
      const newQueryString = concatQueryString(
        currentSearch,
        "keyword",
        keyword
      );
      navigate(`${window.location.pathname}?${newQueryString}`);
    } else navigate(`${window.location.pathname}`);
  };

  return (
    <Banner className="search-programs-preview">
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div>
          <div className="text-center text-des">
            {t("Danh sách chương trình học", "Danh sách chương trình học")}
          </div>
          <div className="text-title text-center">{renderTitle()}</div>
          <div className="text-center text-des">
            {t("Với 1000+ các chương trình học với đa dạng chủ đề", "Với 1000+ các chương trình học với đa dạng chủ đề")}
          </div>
          <Flex align="center" gap={8} className="mt-2">
            <FormInput
              className="input-search"
              placeholder={t("Nhập từ khoá cần tìm", "Nhập từ khoá cần tìm")}
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              onKeyPress={(e) => {
                if (e.code === "enter") {
                  handleSearch();
                }
              }}
            />
            <Button
              className="btn-private-primary h-48px input-search"
              onClick={handleSearch}
            >{t("Tìm kiếm", "Tìm kiếm")}</Button>
          </Flex>
        </div>
      </div>
    </Banner>
  );
}

export default ProgramsSearchBanner;
